import { BreathworkNameDisplay, LocalizedString } from '@breath-lab/types';

export function getPrimaryName(name: LocalizedString, display: BreathworkNameDisplay): string {
  if (display === 'sanskrit') return name.saEn ?? name.en;
  return name.en;
}

export function getSecondaryName(name: LocalizedString, display: BreathworkNameDisplay): string | undefined {
  if (display === 'sanskrit') return name.saEn ? name.en : undefined;
  return name.saEn ?? undefined;
}
